70<template>
    <div class="d-flex flex-row justify-end" style="z-index: 2; transform: translateY(50%);">
        <div class="d-flex flex-column align-center justify-space-around">
            <v-avatar size="42" :color="stateHintBackgroundColor"></v-avatar>
        </div>
    </div>
</template>

<script>
import firebase from "../../../firebaseConfig.js";
import AudioRecorder from "audio-recorder-polyfill";
window.MediaRecorder = AudioRecorder; /* comment this line out to test the regular media recorder, once it works we will uninstall the polyfill */

export default {
    name: "pickup-mobile",
    components: {},
    props: ["isDraftPost", "tawqin",],
    data() {
        return {
            currState: "@pause",
            prevState: "@play",
            stateHintBackgroundColor: "#FFE019",// yellow since we start in a paused state (green = playing, yellow = paused, red = recording)
            audioSeg: {
                segment: 0,
                audioStart: 0,
                audioEnd: 0,
                audioDur: 0,
                audioURL: null,
                error: false,
            },
            hiStep: 60, // might need to change this to 70
            loStep: 20,
            ignore: 500,
            recorder: null,
            recordedChunks: [],
            audioStorageReference: null,
            languageInfo: {},
        };
    },
    methods: {
        handleOrientation: function (event) {
            let gamma = Math.round(Math.abs(event.gamma));
            
            if ((gamma <= this.loStep && this.currState !== "@play") || (gamma <= this.loStep && this.currState === "@play" && this.prevState === "@record")) {
                this.updateState("@play", "@pause", "#588157"/*green*/);
            } else if (gamma > this.loStep && gamma < this.hiStep && this.currState !== "@record") {
                if ((this.currState === "@play" && this.prevState === "@pause") /*|| (this.currState === "@pause" && this.prevState === "@play")*/) {
                    this.updateState("@pause", "@play", "#FFE019"/*yellow*/);
                }
            } else if (gamma < this.hiStep && this.currState === "@record") {
                this.updateState("@play", "@record", "#588157"/*green*/);
            } else if (gamma >= this.hiStep && this.currState !== "@record") {
                this.updateState("@record", "@play", "#FF0000"/*red*/);
            }
        },

        updateState: function (currState, prevState, backgroundColor) {
            this.stateHintBackgroundColor = backgroundColor;
            this.currState = currState;
            this.prevState = prevState;

            this.audioStateAction();
        },
        audioStateAction: function () {
            if (this.currState === "@record") {
                this.startRecording();
            } else if (this.prevState === "@record") {
                this.stopRecording();
            }

            this.$emit('controlVideoState', this.currState, this.prevState);
        },
        startRecording: function () {
            this.audioSeg.audioStart = Number(new Date());
            this.recorder.start();
        },
        stopRecording: function () {
            if (this.recorder.state === "recording") {
                this.audioSeg.audioEnd = Number(new Date());
                this.recorder.stop();
                this.audioSeg.audioDur = this.audioSeg.audioEnd - this.audioSeg.audioStart;
            }
        },
        handleDataAvailable: function (event) {
            const isValidSize = event.data.size > 0;
            const isDurationValid = this.audioSeg.audioDur > this.ignore;

            if (isValidSize && isDurationValid) {
                this.recordedChunks.push(event.data);
                this.uploadAudioRec();
            } else {
                const alertMessage = isDurationValid ? `Audio segment ignored. Please try again!` : `Invalid event data size. Please try again!`;
                this.$store.commit('alertUser', {show: true, text: alertMessage, type: 'snackbar'});
            }
        },
        uploadAudioRec: async function () {
            this.audioSeg.segment++; // so the segments start at 1 and increments each additional time we upload an audio recording
            var audioSeg = { ...this.audioSeg };
            const audioChunks = [...this.recordedChunks];
            this.recordedChunks = []; // clear audio buffer for next recording

            const blob = new Blob(audioChunks, { type: "audio/webm" });
            var metaData = {
                contentType: "audio/webm",
                customMetadata: {
                    aStart: audioSeg.audioStart,
                    aDuration: audioSeg.audioDur,
                    userId: firebase.auth.currentUser.uid,
                    langCode: this.languageInfo.value,
                    location: this.languageInfo.location,
                    model: this.languageInfo.model,
                    recognizer: this.languageInfo.recognizer,
                    // isDev: process.env.NODE_ENV === 'development' ? true : false,
                    isDev: true,
                },
            };
            var storageRef = firebase.storage.ref();

            /***FOR TESTING ONLY***/
            // var rand = Math.random(2);
            // var coinToss = rand < 0.5 ? await storageRef.child(this.audioStorageReference + "/" + audioSeg.segment).put(blob, metaData) : "fail";
            // // console.log("coinToss: ", coinToss);
            // let audioUploaded = coinToss;
            /***END FOR TESTING ONLY***/

            let audioUploaded = await storageRef.child(this.audioStorageReference + "/" + audioSeg.segment).put(blob, metaData);
            audioSeg.error = audioUploaded.state !== "success";
            audioSeg.audioURL = (audioUploaded.state !== "success") ? "failed" : null;
            audioSeg.audioStart = (audioUploaded.state !== "success") ? 0 : audioSeg.audioStart;
            audioSeg.audioEnd = (audioUploaded.state !== "success") ? 0 : audioSeg.audioEnd;
            audioSeg.audioDur = (audioUploaded.state !== "success") ? 0 : audioSeg.audioDur;
            this.$emit("emitAudioSeg", audioSeg);
        },
        disableMicrophone: function () {
            if (this.recorder && this.recorder.stream != undefined) {
                this.recorder.stream.getTracks().forEach((track) => track.stop());
            }
            delete this.recorder;
        },
    },
    watch: {
        tawqin: function (value) {
            this.audioSeg.segment = value.startSegId;
        },
    },
    created: function () {
        window.addEventListener("deviceorientation", this.handleOrientation);
        this.audioSeg.segment = this.tawqin.startSegId;
        this.languageInfo = this.tawqin.languageSelected;
        this.audioStorageReference = `audioSegments/${this.tawqin.postId}/${this.tawqin.audioDataId}`;
    },
    mounted: function () {
        if (this.$navigator.mediaDevices) { // if the user device allows us, get their media.
            var constraints = { audio: true };
            this.$navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                var options = {
                    mimeType: "audio/webm",
                    audioBitsPerSecond: 128000,
                };
                this.recorder = new MediaRecorder(stream, options);
                this.recorder.addEventListener("dataavailable", this.handleDataAvailable);
            }).catch((error) => {
                this.$store.commit('alertUser', { show: true, text: `Error: We cannot access your microphone. ${error.message}`, type: 'snackbar' });
            });
        } // January 17, 2024 - if the user does NOT allow for device, what happens? Do we need to implement error or retry functionality?
    },
    beforeDestroy: function () {
        if (this.recorder) this.recorder.removeEventListener('dataavailable', this.handleDataAvailable);
        window.removeEventListener("deviceorientation", this.handleOrientation);
        this.disableMicrophone();
    },
};
</script>

<style>
.v-btn::before {
    background-color: transparent !important;
}
</style>